import React from 'react';
import { Clock, Trophy, Zap } from 'lucide-react';
export const MiniGame = () => {
  return <section className="space-y-4" data-id="element-10257">
      <div className="flex items-center justify-between" data-id="element-10258">
        <h2 className="text-lg font-bold" data-id="element-10259">Mini-Games</h2>
        <button className="text-sm text-pink-400" data-id="element-10260">View All</button>
      </div>
      <div className="bg-gradient-to-br from-purple-900/40 to-pink-900/40 rounded-xl border border-purple-800/50 overflow-hidden" data-id="element-10261">
        <div className="p-4" data-id="element-10262">
          <h3 className="text-xl font-bold mb-1" data-id="element-10263">Erotic Match-3</h3>
          <p className="text-sm text-gray-300" data-id="element-10264">
            Match symbols to earn rewards and please Sophia
          </p>
          <div className="mt-4 grid grid-cols-6 gap-2" data-id="element-10265">
            {['👙', '🍑', '💋', '🔥', '🍆', '💦', '👙', '🍑', '💋', '🔥', '🍆', '💦'].map((emoji, index) => <div key={index} className="aspect-square flex items-center justify-center bg-gray-800 rounded-md border border-gray-700 text-xl" data-id="element-10266">
                {emoji}
              </div>)}
          </div>
          <div className="mt-4 flex items-center justify-between" data-id="element-10267">
            <div className="flex items-center gap-4" data-id="element-10268">
              <div className="flex items-center gap-1" data-id="element-10269">
                <Trophy size={16} className="text-yellow-400" data-id="element-10270" />
                <span className="text-sm" data-id="element-10271">Level 5</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-10272">
                <span className="text-pink-400" data-id="element-10273">💗</span>
                <span className="text-sm" data-id="element-10274">+20</span>
              </div>
            </div>
            <button className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium" data-id="element-10275">
              Play Now
            </button>
          </div>
        </div>
        <div className="border-t border-purple-800/50 p-3 flex items-center justify-between bg-gray-900/50" data-id="element-10276">
          <div className="flex items-center gap-3" data-id="element-10277">
            <button className="flex items-center gap-1 px-3 py-1 bg-gray-800 rounded-full" data-id="element-10278">
              <Clock size={14} className="text-pink-400" data-id="element-10279" />
              <span className="text-xs" data-id="element-10280">Daily</span>
            </button>
            <button className="flex items-center gap-1 px-3 py-1 bg-pink-900/50 rounded-full" data-id="element-10281">
              <Zap size={14} className="text-pink-400" data-id="element-10282" />
              <span className="text-xs" data-id="element-10283">Cum Quick</span>
            </button>
          </div>
          <div className="text-xs text-gray-400" data-id="element-10284">3 plays left today</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-10285">
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-3" data-id="element-10286">
          <div className="flex items-center gap-2 mb-2" data-id="element-10287">
            <div className="w-8 h-8 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-10288">
              🎯
            </div>
            <h3 className="font-medium" data-id="element-10289">Streak</h3>
          </div>
          <div className="flex items-center justify-between" data-id="element-10290">
            <div data-id="element-10291">
              <p className="text-2xl font-bold" data-id="element-10292">3 Days</p>
              <p className="text-xs text-gray-400" data-id="element-10293">Keep playing daily</p>
            </div>
            <div className="text-xs px-2 py-1 bg-pink-500/20 rounded-full text-pink-400" data-id="element-10294">
              2× XP
            </div>
          </div>
        </div>
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-3" data-id="element-10295">
          <div className="flex items-center gap-2 mb-2" data-id="element-10296">
            <div className="w-8 h-8 flex items-center justify-center bg-purple-500/20 rounded-full text-purple-400" data-id="element-10297">
              🏆
            </div>
            <h3 className="font-medium" data-id="element-10298">High Score</h3>
          </div>
          <div className="flex items-center justify-between" data-id="element-10299">
            <div data-id="element-10300">
              <p className="text-2xl font-bold" data-id="element-10301">12,540</p>
              <p className="text-xs text-gray-400" data-id="element-10302">Ranked #42 today</p>
            </div>
            <button className="text-xs px-2 py-1 bg-purple-500/20 rounded-full text-purple-400" data-id="element-10303">
              Leaderboard
            </button>
          </div>
        </div>
      </div>
    </section>;
};